import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagedCompaniesService {
  private managedCompaniesSubject = new BehaviorSubject<any[]>([]);
  public managedCompanies$ = this.managedCompaniesSubject.asObservable();

  constructor() {
    this.loadManagedCompanies();
  }

  public loadManagedCompanies(): void {
    let managedCompanies = JSON.parse(
      localStorage.getItem('managedCompanies') || '[]'
    );

    // убрать дубликаты из массива
    managedCompanies = managedCompanies.reduce((acc, company) => {
      const existingCompany = acc.find((c) => c.id === company.id);
      if (!existingCompany) {
        acc.push(company);
      }
      return acc;
    }, []);

    if (managedCompanies.length > 10) {
      managedCompanies = managedCompanies.slice(managedCompanies.length - 10); // оставить только последние 10 элементов
      localStorage.setItem(
        'managedCompanies',
        JSON.stringify(managedCompanies)
      );
    }

    this.managedCompaniesSubject.next(managedCompanies);
  }

  public updateManagedCompanies(company: any): void {
    const managedCompanies = JSON.parse(
      localStorage.getItem('managedCompanies') || '[]'
    );

    const existingCompany = managedCompanies.find((c) => c.id === company.id);
    if (existingCompany) {
      // компания с таким же id уже существует, обновляем данные
      Object.assign(existingCompany, company);
    } else {
      // добавляем новую компанию
      if (managedCompanies.length >= 10) {
        managedCompanies.shift(); // удалить первый элемент
      }
      managedCompanies.push(company);
    }

    const otherSelectedCompanyIndex = managedCompanies.findIndex(
      (c) => c.selected && c.id !== company.id
    );
    if (otherSelectedCompanyIndex >= 0) {
      managedCompanies[otherSelectedCompanyIndex].selected = false;
    }

    localStorage.setItem('managedCompanies', JSON.stringify(managedCompanies));
    this.managedCompaniesSubject.next(managedCompanies);
  }

  public deleteManagedCompany(companyId): void {
    const managedCompanies = JSON.parse(
      localStorage.getItem('managedCompanies') || '[]'
    );

    const companyIndex = managedCompanies.findIndex((c) => c.id === companyId);
    if (companyIndex >= 0) {
      managedCompanies.splice(companyIndex, 1);

      localStorage.setItem(
        'managedCompanies',
        JSON.stringify(managedCompanies)
      );
      this.managedCompaniesSubject.next(managedCompanies);
    }
  }
}
